export default "__VITE_ASSET__BEpDULVR__"